import { FormFieldState } from '@rippling/utils';
import Cookies from 'universal-cookie';

import { SchedulerFlowType } from '../types';

export default function useSchedulerFlow({
  schedulerBaseUrl = '',
  schedulerCountries,
  schedulerMaximumNumberOfEmployees,
  schedulerMinimumNumberOfEmployees,
  schedulerRestrictByCountryPicked,
  schedulerRestrictByNumberOfEmployees,
  values,
}: {
  schedulerBaseUrl: string;
  schedulerCountries: string[] | undefined,
  schedulerFlowType: SchedulerFlowType | undefined,
  schedulerMaximumNumberOfEmployees: number | undefined,
  schedulerMinimumNumberOfEmployees: number | undefined,
  schedulerRestrictByCountryPicked: boolean,
  schedulerRestrictByNumberOfEmployees: boolean,
  values: FormFieldState,
}) {
  if (!schedulerBaseUrl) {
    console.error('NEXT_PUBLIC_DEMOTIME_BASE_URL is not set');

    return false;
  }

  const {
    Company,
    Country,
    Email,
    FirstName,
    LastName,
    NumberOfEmployees,
    Phone,
  } = values;

  if (!Country || !NumberOfEmployees || !Email || !FirstName || !LastName || !Phone || !Company) {
    console.error('Missing required form fields for scheduler flow:', values);

    return false;
  }

  const cookies = new Cookies();

  const utmRefacc = cookies.get('utm_refacc');
  const utmSource = cookies.get('utm_source');

  // Special exclusion case for the demo time flow if the user is coming from specific UTM params/values
  if (utmRefacc && ['broker-referral', 'accountant-referral'].includes(utmSource)) {
    return false;
  }

  let isSchedulerCountry = true;
  let isSchedulerEmployeeSizeInRange = true;

  if (schedulerRestrictByCountryPicked && schedulerCountries) {
    isSchedulerCountry = schedulerCountries.includes(Country as string);
  }

  if (schedulerRestrictByNumberOfEmployees && schedulerMaximumNumberOfEmployees && schedulerMinimumNumberOfEmployees) {
    const numEmployees = Number(NumberOfEmployees);

    isSchedulerEmployeeSizeInRange = numEmployees >= schedulerMinimumNumberOfEmployees
        && numEmployees <= schedulerMaximumNumberOfEmployees;
  }

  return isSchedulerCountry && isSchedulerEmployeeSizeInRange;
}
